// import { store } from '@/store/store'
import {
    temAcesso
} from '@/bibliotecas/seguranca/authLib'

const Recebimentos = () => import('./Recebimentos.vue')
// const Finalizacao = () => import('./Finalizacao.vue')
// const FinalizacaoAssociarEntregas = () => import('./FinalizacaoAssociarEntregas.vue')
// const UsuarioPerfisAcesso = () => import('./UsuarioPerfisAcesso.vue')

export default {
    path: 'recebimentos',
    name: 'Credores_Recebimentos',
    component: Recebimentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-RECEB-00')) {
            next()
        }
    },
    children: [
        // {
        //   path: 'inserir',
        //   name: 'Usuarios_Inserir',
        //   component: UsuarioForm,
        //   beforeEnter: (to, from, next) => {
        //     if (temAcesso('CTRLACS-USR-01')) {
        //       next()
        //     }
        //   }
        // },
        // {
        //   path: 'detalhar/:finalizacaoId',
        //   name: 'Credenciados_Finalizacoes_Detalhar',
        //   component: Finalizacao,
        //   beforeEnter: (to, from, next) => {
        //     if (temAcesso('CRED-FIN-02')) {
        //       next()
        //     }
        //   },
        //   children: [
        //     {
        //       path: 'associarentregas',
        //       name: 'Credenciados_Finalizacoes_AssociarEntregas',
        //       component: FinalizacaoAssociarEntregas,
        //       beforeEnter: (to, from, next) => {
        //         if (temAcesso('CRED-FIN-03')) {
        //           next()
        //         }
        //       }
        //     }
        //   ]
        // }
        // {
        //   path: 'atualizar/:usuarioId',
        //   name: 'Usuarios_Atualizar',
        //   component: UsuarioForm,
        //   beforeEnter: (to, from, next) => {
        //     if (temAcesso('CTRLACS-USR-03')) {
        //       next()
        //     }
        //   }
        // },
        // {
        //   path: 'perfisacesso/:usuarioId',
        //   name: 'Usuarios_PerfisAcesso',
        //   component: UsuarioPerfisAcesso,
        //   beforeEnter: (to, from, next) => {
        //     if (temAcesso('CTRLACS-USR-06')) {
        //       next()
        //     }
        //   }
        // }
    ]
}



// WEBPACK FOOTER //
// ./src/modulos/credores/recebimentos/RecebimentosRotas.js